var map = {
	"./after_party.png": 1933,
	"./after_party@2x.png": 1934,
	"./brunch.png": 1935,
	"./brunch@2x.png": 1936,
	"./camera.svg": 1937,
	"./ceremony.png": 1938,
	"./ceremony@2x.png": 1939,
	"./check.svg": 730,
	"./checklist-white-bg.svg": 1940,
	"./checklist.svg": 1941,
	"./chevron-white-thick-left.png": 1942,
	"./chevron-white-thick-right.png": 1943,
	"./chevron-white-thick.png": 1944,
	"./confetti.svg": 1945,
	"./dashboard.svg": 1946,
	"./desktop_events.svg": 1947,
	"./download.svg": 1948,
	"./dropdown-focus.svg": 1907,
	"./dropdown.svg": 1906,
	"./envelope.svg": 1949,
	"./envelope_gray.svg": 1950,
	"./events.svg": 1951,
	"./faq-checklist.png": 1952,
	"./faq-checklist.svg": 1953,
	"./faq-guestlist.png": 1954,
	"./faq-guestlist.svg": 1955,
	"./faq-registry.png": 1956,
	"./faq-registry.svg": 1957,
	"./faq-website.png": 1958,
	"./faq-website.svg": 1959,
	"./guest_list-white-bg.svg": 1960,
	"./guest_list.svg": 1961,
	"./guestlist-white-bg-trimmed.svg": 1962,
	"./help.svg": 1963,
	"./icon-chrome.png": 1964,
	"./icon-chrome.svg": 513,
	"./icon-invites.png": 1965,
	"./icon-invites.svg": 1966,
	"./icon-website.svg": 1967,
	"./iconX.svg": 489,
	"./icon_empty.svg": 943,
	"./illustrative_website.svg": 1622,
	"./menu.svg": 1968,
	"./np_hidden.png": 1969,
	"./other.png": 1970,
	"./other@2x.png": 1971,
	"./profile-photo.png": 1313,
	"./profile-photo@2x.png": 1972,
	"./reception.png": 1973,
	"./reception@2x.png": 1974,
	"./redPresent.svg": 1975,
	"./registry-white-bg.svg": 1976,
	"./registry.svg": 1977,
	"./rehearsal_dinner.png": 1978,
	"./rehearsal_dinner@2x.png": 1979,
	"./remove.svg": 526,
	"./silhouette.png": 1980,
	"./trashbin.png": 1981,
	"./trashcan.svg": 1982,
	"./website-white-bg.svg": 1983,
	"./website.svg": 1984,
	"./wedding.png": 1985,
	"./wedding@2x.png": 1986,
	"./welcome_event.png": 1987,
	"./welcome_event@2x.png": 1988,
	"./x-circle-dark.svg": 1989,
	"./x-circle-light.svg": 1990
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 942;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 942
// module chunks = 68